import React from "react";

const ClearAllButton = ({ onClearAll, clearAllButtonClass }) => {
  return (
    <button id="clear-all" className={clearAllButtonClass} onClick={onClearAll}>
      Clear All
      <img src="/documents/d/surekhatech/clear-btn" alt="clear-button" />
    </button>
  );
};

export default ClearAllButton;
